// extracted by mini-css-extract-plugin
export const widget = "widget-icon-module--widget--1teSd";
export const widgetDetails = "widget-icon-module--widget-details--3aUHF";